/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dropvalidationcontingentrequired3Inputs */

const en_dropvalidationcontingentrequired3 = /** @type {(inputs: Dropvalidationcontingentrequired3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter the number of prizes (1 to 10,000).`)
};

const de_dropvalidationcontingentrequired3 = /** @type {(inputs: Dropvalidationcontingentrequired3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gib die Zahl der Preise an (1 bis 10.000).`)
};

/**
* | output |
* | --- |
* | "Enter the number of prizes (1 to 10,000)." |
*
* @param {Dropvalidationcontingentrequired3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const dropvalidationcontingentrequired3 = /** @type {((inputs?: Dropvalidationcontingentrequired3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dropvalidationcontingentrequired3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_dropvalidationcontingentrequired3(inputs)
	return de_dropvalidationcontingentrequired3(inputs)
});
export { dropvalidationcontingentrequired3 as "dropValidationContingentRequired" }